import { useQuery } from '@tanstack/react-query'
import { fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth'

import { createCognitoUser } from '@/graphql/mutations'
import { getCognitoUser } from '@/graphql/queries'
import { isAdmin } from '@/utils'
import {
  CognitoUser,
  CreateCognitoUserMutation,
  CreateCognitoUserMutationVariables,
  GetCognitoUserQuery,
  GetCognitoUserQueryVariables,
  Permission,
  Theme,
} from '@/utils/api'
import graphQLRequest from '@/utils/graphqlClient'

export const getOrCreateVailUser = async (
  email: string,
  id?: string,
  role?: Permission
) => {
  if (id) {
    const data = await graphQLRequest<
      GetCognitoUserQuery,
      GetCognitoUserQueryVariables
    >(getCognitoUser, { id })

    const dataUser = data.data?.getCognitoUser
    if (dataUser) return dataUser as CognitoUser
  }
  const d = await graphQLRequest<
    CreateCognitoUserMutation,
    CreateCognitoUserMutationVariables
  >(createCognitoUser, {
    input: {
      demosShown: [],
      email,
      id,
      name: email,
      role: !!role ? role : Permission.user,
      settings: {
        fontSize: 14,
        theme: Theme.light,
      },
    },
  })
  return d.data?.createCognitoUser as CognitoUser
}

export const useMyUser = () => {
  return useQuery({
    queryFn: async () => {
      const { userId: id } = await getCurrentUser()
      const { email } = await fetchUserAttributes()
      return await getOrCreateVailUser(
        email || '',
        id,
        (await isAdmin()) ? Permission.administrator : Permission.user
      )
    },

    queryKey: ['my user'],
  })
}
export default useMyUser
